export const defaultThemeStyles: any = {
		general: {
			//Color del input de nuevo mensaje
			color: '#000000',
			//Color de background del input de nuevo mensaje y de buscar sala en el menu de selección de salas
			backgroundInput: '#FFF',
			//Color del placeholder de nuevo mensaje
			colorPlaceholder: '#000000',
			colorCaret: '#1976d2',
			colorSpinner: '#333',
			//Color del borde que separa el header de la conversación y el menú de selección de salas
			borderStyle: '2px solid #CFDC35',
			//Color del background de la burbuja que aparece cuando se reciben nuevos mensajes más abajo en la conversación
			backgroundScrollIcon: '#B7C65D'
		},

		container: {
			border: 'none',
			borderRadius: '4px',
			boxShadow:
				'0px 1px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)'
		},

		header: {
			//Color del background del header con el nombre de sala
			background: '#F4F4F4',
			//Color texto nombre de la sala
			colorRoomName: '#000000',
			//Color texto descripcion de la sala
			colorRoomInfo: '#000000'
		},

		footer: {
			//Background del footer que contiene el input y el boton de enviar y de emojis
			background: '#F4F4F4',
			//Color del borde del input
			borderStyleInput: '2px solid #CFDC35',
			borderInputSelected: '#1976d2',
			backgroundReply: '#e5e5e6',
			backgroundTagActive: '#e5e5e6'
		},

		content: {
			//background del cuadro donde aparece la conversación
			background: '#fff'
		},

		sidemenu: {
			//Color del background de selección de sala
			background: '#F4F4F4',
			//Color de background de una sala no actual sobre la que esté el ratón en el menu de selección
			backgroundHover: '#f6f6f6',
			//Color de background de la sala actual en el menu de selección
			backgroundActive: '#B7C65D',
			colorActive: '#1976d2',
			borderColorSearch: '#CFDC35'
		},

		dropdown: {
			background: '#fff',
			backgroundHover: '#f6f6f6'
		},

		message: {
			//Background de mensajes de otros usuarios ( a la izquierda )
			background: '#FFFFFF',
			//Background de mensajes del usuario ( a la derecha )
			backgroundMe: '#CBD4C2',
			//Color del texto de mensajes
			color: '#000000',
			colorStarted: '#9ca6af',
			backgroundDeleted: '#dadfe2',
			colorDeleted: '#757e85',
			//Color del nombre de usuario que aparece encima de los mensajes de otros usuarios ( a la izquierda )
			colorUsername: '#9ca6af',
			//Color de la hora y minuto que aparece bajo cada mensaje
			colorTimestamp: '#828c94',
			//Background de la burbuja que indica cambio de fecha en una conversación
			backgroundDate: '#F4F4F4',
			//Color del texto de la burbuja que indica cambio de fecha en una conversación
			colorDate: '#000000',
			backgroundSystem: '#e5effa',
			colorSystem: '#505a62',
			backgroundMedia: 'rgba(0, 0, 0, 0.15)',
			backgroundReply: 'rgba(0, 0, 0, 0.08)',
			colorReplyUsername: '#0a0a0a',
			colorReply: '#6e6e6e',
			colorTag: '#0d579c',
			backgroundImage: '#31b314',
			//Color de la barra y texto que aparecen indicando el principio de los nuevos mensajes
			colorNewMessages: '#CFDC35',
			//Background contador de nuevos mensajes más abajo en la conversación
			backgroundScrollCounter: '#B7C65D',
			//Color del numero del contador de nuevos mensajes más abajo en la conversación
			colorScrollCounter: '#000000',
			backgroundReaction: '#eee',
			borderStyleReaction: '1px solid #eee',
			backgroundReactionHover: '#fff',
			borderStyleReactionHover: '1px solid #ddd',
			colorReactionCounter: '#0a0a0a',
			backgroundReactionMe: '#cfecf5',
			borderStyleReactionMe: '1px solid #3b98b8',
			backgroundReactionHoverMe: '#cfecf5',
			borderStyleReactionHoverMe: '1px solid #3b98b8',
			colorReactionCounterMe: '#0b59b3',
			backgroundAudioRecord: '#eb4034',
			backgroundAudioLine: 'rgba(0, 0, 0, 0.15)',
			backgroundAudioProgress: '#455247',
			backgroundAudioProgressSelector: '#455247'
		},

		markdown: {
			background: 'rgba(239, 239, 239, 0.7)',
			border: 'rgba(212, 212, 212, 0.9)',
			color: '#e01e5a',
			colorMulti: '#0a0a0a'
		},

		//Salas en el menu de selección de sala
		room: {
			//Color del nombre de la sala
			colorUsername: '#000000',
			//Color del último mensaje en la sala
			colorMessage: '#000000',
			//Color de la hora del último mensaje en la sala
			colorTimestamp: '#000000',
			colorStateOnline: '#4caf50',
			colorStateOffline: '#9ca6af',
			backgroundCounterBadge: '#0696c7',
			colorCounterBadge: '#fff'
		},

		emoji: {
			//Color del background del menú de selección de emojis
			background: '#fff'
		},

		icons: {
			search: '#9ca6af',
			add: '#1976d2',
			toggle: '#0a0a0a',
			menu: '#0a0a0a',
			close: '#9ca6af',
			closeImage: '#fff',
			file: '#1976d2',
			paperclip: '#1976d2',
			closeOutline: '#000',
			//Color del icono de enviar (no desactivado)
			send: '#000000',
			//Color del icono de enviar (desactivado)
			sendDisabled: '#7C7B7B',
			//Color del icono de emoji
			emoji: '#000000',
			emojiReaction: 'rgba(0, 0, 0, 0.3)',
			document: '#1976d2',
			pencil: '#9e9e9e',
			checkmark: '#9e9e9e',
			checkmarkSeen: '#0696c7',
			eye: '#fff',
			dropdownMessage: '#fff',
			dropdownMessageBackground: 'rgba(0, 0, 0, 0.25)',
			dropdownRoom: '#9e9e9e',
			dropdownScroll: '#0a0a0a',
			microphone: '#1976d2',
			audioPlay: '#455247',
			audioPause: '#455247',
			audioCancel: '#eb4034',
			audioConfirm: '#1ba65b'
		}
}